export default __webpack_public_path__ + "static/media/logo_text.6e7e62c8.svg";